import React,{useState} from 'react';
import MovieCard from './MovieCard';

export default function SearchMovie(){

    const [query,setQuery] = useState('');
    const [movies,setMovies] = useState([]);

    const searchmve = async (e) => {
        e.preventDefault();
        const api_key = "a0eec856b60ba8dbcadff708dfb597cf";
        const url = `https://api.themoviedb.org/3/search/movie?api_key=${api_key}&language=en-US&query=${query}&page=1&include_adult=false`;

        try{
            const res = await fetch(url);
            const data = await res.json();
            console.log(data.results);
            setMovies(data.results);
        
        }catch(error){
            console.error(error);
        }
    }

    return(
        <>
        <form className="form" onSubmit={searchmve}>
            <label className="label" htmlFor="query">Movie Name</label>
            <input className="input" type="text" name="query" placeholder="e.g. Avengers" value={query} onChange={(e)=>setQuery(e.target.value)}></input>
            <button className="button" type="submit">Search</button>
        </form>
        <div className="cardList">
            {movies.filter(movie=>movie.poster_path).map(movie => (
                <MovieCard movie = {movie} key ={movie.id}/> 
            )            
            )}
            
        </div>
        </>
    )

    
}
